import { createFileRoute, redirect } from "@tanstack/react-router";
import { EndpointDetail } from "../../features/inference/endpoint-detail";

/** Tabs folded into another keep their URLs: Usage into Overview, Configuration into API. */
const MOVED: Record<string, string> = { usage: "overview", configuration: "api" };

export const Route = createFileRoute("/_authed/$org/$project/inferenceendpoints/$name/$tab")({
  beforeLoad: ({ params, search }) => {
    const moved = MOVED[params.tab];
    if (moved) throw redirect({ to: "/$org/$project/inferenceendpoints/$name/$tab", params: { ...params, tab: moved }, search, replace: true });
  },
  component: EndpointPage,
});

function EndpointPage() {
  const { org, project, name, tab } = Route.useParams();
  return <EndpointDetail scope={{ org, project }} name={name} tab={tab} />;
}
